async function buildDealerInfomation(_ref) {
  let {
    vin,
    ownerDetailsFetcher
  } = _ref;
  // fetch
  if (typeof ownerDetailsFetcher === 'function' && vin) {
    const {
      owner,
      listing
    } = (await ownerDetailsFetcher(vin)) || {};
    if (owner && listing) {
      return {
        owner,
        listing
      };
    }
  }
  return {};
}
export { buildDealerInfomation as default };
